import type { ClientResponse, CustomObject } from '@commercetools/platform-sdk';

import type { ApiClientDetails, PatchCustomObjectDraft, PatchData } from '../../types';
import { customObjectApi } from './customObject';

const container = 'ct-patch';

export function patchesApi(apiClientDetails: ApiClientDetails) {
    const { fetchCustomObjects, createCustomObject, removeCustomObjects } = customObjectApi(apiClientDetails);

    function listPatches(limit?: number): Promise<CustomObject[]> {
        return fetchCustomObjects(container, undefined, limit);
    }

    function removePatches(patches: CustomObject[]): Promise<ClientResponse<CustomObject>>[] {
        return removeCustomObjects(patches);
    }

    async function createPatch(key: string, patchData: PatchData): Promise<CustomObject> {
        return (
            await createCustomObject(<PatchCustomObjectDraft>{
                container,
                key,
                value: patchData,
            })
        ).body;
    }

    return {
        listPatches,
        removePatches,
        createPatch,
    };
}
